/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Vertragversendet1Inputs */

const de__field_vertragversendet1 = /** @type {(inputs: _Field_Vertragversendet1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vertrag versendet`)
};

/**

* @param {_Field_Vertragversendet1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_vertragversendet1 = /** @type {((inputs?: _Field_Vertragversendet1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Vertragversendet1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_vertragversendet1(inputs)
});
export { _field_vertragversendet1 as "_field_vertragVersendet" }